import $ from 'jquery';

export default function(icon,color){

  if(!color){
    color = '#FFFFFF'
  }

  var setSize = function(){
    div.find('svg')
    .css({
      width: '100%',
      height: '100%',
    })
  }

  var setColor = function(c){
    if(c){
      color = c
    }
    var all = div.find('*')
    div.find('*').attr({fill: color})
  }

  var div = $('<div>');

  if(!window.iconCache){
    window.iconCache = {};
  }

  var setIcon = function(i){

    if(i){
      icon = i
    }

    div.empty()

    if(window.iconCache[icon]){
      div.html(window.iconCache[icon])
      setSize()
      setColor()
    } else {
      div.load('asset/'+icon+'.svg',function(){
        window.iconCache[icon] = $(this).html()
        setSize()
        setColor()
      })
    }

  }

  div.setColor = setColor
  div.setIcon = setIcon

  setIcon()

  return div;

}



// WEBPACK FOOTER //
// ./src/client/component/icon/icon.js